<script setup>
import IconBurger from '@/components/icons/iconBurger.vue'
import { ref } from 'vue'
import NavbarItem from '../components/navbarItem.vue'
const listItems = ref([
  {
    typeItem: 'megamenu',
    title: 'Categorías',
    toLink: '',
    isOpen: false,
    childrenItems: [
      {
        title: 'hola 1',
        toLink: '',
        subItems: [
          {
            head: true,
            title: 'Gorras',
            toLink: '',
          },
          {
            head: false,
            title: 'Gorra de natación',
            toLink: '/productos/product-1-cat-1',
          },
          {
            head: false,
            title: 'Gorra de golf',
            toLink: '/productos/product-2-cat-1',
          },
          {
            head: false,
            title: 'Viseras',
            toLink: '/productos/product-3-cat-1',
          },
        ],
      },
      {
        title: 'hola 2',
        toLink: '',
        subItems: [
          {
            head: true,
            title: 'Pantalones',
            toLink: '',
          },
          {
            head: false,
            title: 'Pantalón deportivo hombres',
            toLink: '/productos/product-1-cat-2',
          },
          {
            head: false,
            title: 'Pantalón deportivo mujeres',
            toLink: '/productos/product-2-cat-2',
          },
          {
            head: false,
            title: 'Pantalonetas',
            toLink: '/productos/product-3-cat-2',
          },
        ],
      },
      {
        title: 'hola 3',
        toLink: '',
        subItems: [
          {
            head: true,
            title: 'Polos',
            toLink: '',
          },
          {
            head: false,
            title: 'Polos deportivos hombres',
            toLink: '/productos/product-1-cat-3',
          },
          {
            head: false,
            title: 'Polos deportivos mujeres',
            toLink: '/productos/product-2-cat-3',
          },
          {
            head: false,
            title: 'Polos deportivos niños',
            toLink: '/productos/product-3-cat-3',
          },
        ],
      },
      {
        title: 'hola 4',
        toLink: '',
        subItems: [
          {
            head: true,
            title: 'Complementos',
            toLink: '',
          },
          {
            head: false,
            title: 'Tabla de natación',
            toLink: '/productos/product-1-cat-4',
          },
          {
            head: false,
            title: 'Lentes para nadar',
            toLink: '/productos/product-2-cat-4',
          },
          {
            head: false,
            title: 'Guantes',
            toLink: '/productos/product-3-cat-4',
          },
        ],
      },
    ],
  },
  {
    typeItem: 'solo',
    title: 'Nosotros',
    toLink: '/sobre-nosotros',
    isOpen: false,
    childrenItems: [],
  },
  {
    typeItem: 'solo',
    title: 'Contacto',
    toLink: '/contacto',
    isOpen: false,
    childrenItems: [],
  },
])

const updateIsOpen = (index, isOpen) => {
  listItems.value[index].isOpen = isOpen
}

const menuMobile = ref(false)
</script>
<template>
  <div class="block lg:hidden">
    <li class="dropdown inline-block relative ps-0.5 z-[101]">
      <button
        @click.prevent="menuMobile = !menuMobile"
        class="size-9 inline-flex items-center justify-center tracking-wide align-middle duration-500 text-base text-center rounded-full text-white"
        type="button"
      >
        <IconBurger :animate="menuMobile" />
      </button>
    </li>
    <div class="fixed top-0 left-0 h-screen w-full bg-black opacity-60 z-[99]" :class="menuMobile ? 'flex' : 'hidden'"></div>
    <div
      class="fixed block top-0 left-0 h-screen w-full z-[100] bg-white text-dark  max-w-[500px] transition-all duration-500 ease-out transform"
      :class="menuMobile ? 'translate-x-0' : '-translate-x-full'"
    >
      <div id="" class="block lg:hidden p-4 pt-[74px]">
        <ul class="navigation-menu flex flex-col">
          <NavbarItem
            v-for="(item, index) in listItems"
            :key="index"
            :type-item="item.typeItem"
            :title="item.title"
            :to-link="item.toLink"
            :children-items="item.childrenItems"
            :is-open="item.isOpen"
            :is-mobile="true"
            @update:isOpen="(isOpen) => updateIsOpen(index, isOpen)"
          />
        </ul>
      </div>
    </div>
  </div>
</template>
<style lang="scss" scoped></style>
